import React, {  useState } from 'react';
import Sidebar from './Sidebar';
import MainContent from './MainContent';
import Box from '@mui/material/Box';
import { useLocation } from 'react-router-dom';
import { IconButton,useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme, Theme } from '@mui/material/styles';

const Home: React.FC = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const location = useLocation();
  const theme = useTheme<Theme>(); // Get the theme and ensure it is of type Theme
  const isLargerThanXSmall = useMediaQuery(theme.breakpoints.up('xs'));
  const isLargerThanSmall = useMediaQuery(theme.breakpoints.up('sm'));
  const isLargerThanMedium = useMediaQuery(theme.breakpoints.up('md'));
  const isLargerThanLarge = useMediaQuery(theme.breakpoints.up('lg'));

  let size;
  if (isLargerThanLarge) size = '18vw'
  else if (isLargerThanMedium) size = '17vw'
  else if(isLargerThanSmall) size = '16vw'
  else if (isLargerThanXSmall) size = '7vw'
  else size='5vw'


  return (
      <Box sx={{ display: 'flex' }}>
        <IconButton
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        sx={{
          position: 'absolute',
          top: 10,
          left: isSidebarOpen ? size : '10px',
          zIndex: 10,
          backgroundColor: 'transparent',
          color: 'black',
          transition: 'all 0.3s ease',
          p: 0,
        }}
      >
        {isSidebarOpen ? <CloseIcon /> : <MenuIcon />} {/* Toggle between Menu and Close icon */}
      </IconButton>

          {/* <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              sx={{
                position: 'absolute',
                top: 10,
                left: isSidebarOpen ? size : '10px',
                zIndex: 10,
                backgroundColor: 'transparent',
                color: 'black',
                transition: 'all 0.3s ease',
                p:0
            }}
            >
                <MenuIcon />
          </IconButton> */}
          
            <Sidebar location={location} isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
          <MainContent location={location} isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen}/>
    </Box>
  );
};

export default Home;
